import { render, staticRenderFns } from "./FaultCard.vue?vue&type=template&id=5c8e24c8&scoped=true"
import script from "./FaultCard.vue?vue&type=script&lang=js"
export * from "./FaultCard.vue?vue&type=script&lang=js"
import style0 from "./FaultCard.vue?vue&type=style&index=0&id=5c8e24c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e24c8",
  null
  
)

export default component.exports